<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.title`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" fab flat color="gray-6" :disabled="isLoading" @click="close()">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form class="form--custom" novalidate>
        <div class="section section--border-b">
          <v-card-text class="pt-0 px-4">
            <label>{{ $t(`${namespace}.form.fieldRecipientsLabel`) }}</label>
            <v-text-field
              v-model="form.recipientsName"
              :placeholder="$t(`${namespace}.form.fieldRecipientsPlaceholder`)"
              :error-messages="errors.collect($t(`${namespace}.form.fieldRecipientsName`))"
              v-validate="{ required: true }"
              :data-vv-name="$t(`${namespace}.form.fieldRecipientsName`)"
              required
              flat
              outline
              solo
              color="accent"
            />

            <label>{{ $t(`${namespace}.form.fieldRecipientsPhoneLabel`) }}</label>
            <v-text-field
              v-model="form.recipientsPhone"
              type="tel"
              :placeholder="$t(`${namespace}.form.fieldRecipientsPhonePlaceholder`)"
              :error-messages="errors.collect($t(`${namespace}.form.fieldRecipientsPhoneName`))"
              v-validate="{
                required: true,
                min: 15,
                max: 15
              }"
              :data-vv-name="$t(`${namespace}.form.fieldRecipientsPhoneName`)"
              required
              flat
              outline
              solo
              color="accent"
              maxlength="15"
              @input="setPhoneMask($event, 'phone')"
            />

            <v-checkbox
              v-model="terms"
              color="accent"
              class="ma-0 pa-0"
              :error-messages="errors.collect($t(`${namespace}.form.fieldTermsName`))"
              v-validate="{ required: true }"
              :data-vv-name="$t(`${namespace}.form.fieldTermsName`)"
              required
            >
              <template slot="label">
                <label
                  v-html="`${$t(`${namespace}.form.fieldTermsLabel`)} ${getRideCategoryTaxiCategoryName(delivery99Type)}`"
                  @click="handleTermsClick"
                />
              </template>
            </v-checkbox>
          </v-card-text>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>
          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close()"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            type="button"
            :disabled="isLoading"
            :loading="isLoading"
            round
            depressed
            color="accent"
            @click="callCar"
          >
            {{ $t(`${namespace}.form.submitButton`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { masks } from 'utils/masks'
import { getRideCategoryByAttr } from 'utils/functions'

export default {
  name: 'WebCallDeliveryDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    delivery99Type: {
      type: String,
      default: 'delivery99'
    }
  },
  computed: {
    terms: {
      get () {
        return this.form.terms ? true : null
      },
      set (val) {
        this.form.terms = val ? true : null
      }
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.deliveryDialog',

      // default
      isLoading: false,
      isDisabled: false,

      // fields
      form: {
        recipientsName: null,
        recipientsPhone: null,
        terms: null
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    setPhoneMask (val, mask) {
      if (val && mask) {
        this.form.recipientsPhone = masks[mask](val)
      }
    },

    resetAllFields () {
      // default
      this.isLoading = false
      this.isDisabled = false

      // fields
      this.form = {
        recipientsName: null,
        recipientsPhone: null,
        terms: false
      }
    },

    close (val) {
      this.$emit('close', val)
    },

    createHiddenElement (url, target = '_blank') {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = url
      hiddenElement.target = target
      hiddenElement.click()
    },

    getRideCategoryTcUrl (value = '') {
      return getRideCategoryByAttr(this, { key: 'value', value: value }).tcUrl
    },
    getRideCategoryTaxiCategoryName (value = '') {
      return getRideCategoryByAttr(this, { key: 'value', value: value }).text
    },
    handleTermsClick ($event) {
      $event.preventDefault()
      const cls = $event.target.classList

      if (cls.contains('accent--text')) {
        const tcUrl = this.getRideCategoryTcUrl(this.delivery99Type)
        if (tcUrl) {
          this.createHiddenElement(tcUrl)
        }
      }
    },

    async callCar () {
      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          this.close({ ...this.form })
        }
      } catch (error) {
        console.log('ERROR', error)
        return error
      }
    }
  },
  watch: {
    visible (val) {
      // fix validation error when close dialog
      this.$validator._paused = !val
      this.resetAllFields()
    }
  }
}
</script>
